interface Options {
  delayInMs: number;
}

type DebouncedCallback = () => void;

const defaultOptions: Options = {
  delayInMs: 2000,
};

export function withSearchSyncDelay(
  cb: DebouncedCallback,
  options: Options = defaultOptions,
): void {
  setTimeout(() => {
    cb();
  }, options.delayInMs);
}

/**
 * Delay that keeps `isLoading` state for query until delayInMs is reached and requests have been resolved
 */
export async function withSearchSyncDelayPromise<T = unknown>(
  item: Promise<T>,
  options: Options = defaultOptions,
) {
  const [response] = await Promise.all([
    item,
    new Promise((resolve) => setTimeout(() => resolve(true), options.delayInMs)),
  ]);
  return response;
}
